'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['color:', ';transition:color cubic-bezier(0.47,0,0.75,0.72) 0.3s;cursor:pointer;text-decoration:none;&:hover{color:', ';}&:active{color:', ';}'], ['color:', ';transition:color cubic-bezier(0.47,0,0.75,0.72) 0.3s;cursor:pointer;text-decoration:none;&:hover{color:', ';}&:active{color:', ';}']);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _mcsLiteTheme = require('mcs-lite-theme');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var A = _styledComponents2.default.a(_templateObject, function (props) {
  return props.theme.color[props.color];
}, function (props) {
  return (0, _mcsLiteTheme.darken1)(props.theme.color[props.color]);
}, function (props) {
  return (0, _mcsLiteTheme.darken2)(props.theme.color[props.color]);
});

A.displayName = 'A';
A.propTypes = {
  color: _propTypes2.default.string
};
A.defaultProps = {
  color: 'primary'
};

exports.default = A;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../mcs-lite-ui/lib/A/A.js
// module id = 340
// module chunks = 4